import { useState, useEffect } from "react";

function getStorageValue(key, defaultValue) {
  // getting stored value
  const saved = localStorage.getItem(key);
  try {
    const initial = JSON.parse(saved);
    return initial;
  }
  catch {
    return defaultValue;
  }
  
  
}

const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    // storing input name
    const setVal = value === undefined ? null : value;
    localStorage.setItem(key, JSON.stringify(setVal));
  }, [key, value]);

  return [value, setValue];
};

export default useLocalStorage;